export const PHARMACY_BANK_CONNECTION_PERMISSION = {
  VIEW: 'SYS_PHARMACY_BANK_CONNECTION_VIEW',
  ADD: 'SYS_PHARMACY_BANK_CONNECTION_ADD',
  EDIT: 'SYS_PHARMACY_BANK_CONNECTION_EDIT',
  DELETE: 'SYS_PHARMACY_BANK_CONNECTION_DEL',
};

export const PHARMACY_EINVOICE_CONNECTION_PERMISSION = {
  VIEW: 'SYS_PHARMACY_EINVOICE_CONNECTION_VIEW',
  ADD: 'SYS_PHARMACY_EINVOICE_CONNECTION_ADD',
  EDIT: 'SYS_PHARMACY_EINVOICE_CONNECTION_EDIT',
  DELETE: 'SYS_PHARMACY_EINVOICE_CONNECTION_DEL',
};

export const ACTIVE_OPTIONS = [
  { value: 1, label: 'Kích hoạt' },
  { value: 0, label: 'Tạm tắt' },
];

export const MASKED_SECRET = 'xxxxxxxxxx';
